<h3 mat-dialog-title>
  <div class="modal-header">
    <span class="modal-title">{{data["selected_row"].name}} - {{data["selected_row"].room}}</span>
    <span class="fx-spacer"></span>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</h3>

<mat-dialog-content>
  <div class="col-12">
    <div class="d-flex">
      <h4>{{'app.device-name' | translate}}</h4>
      <div class="editName ml-auto">
        <span class="mr-2">{{data["selected_row"].name}}</span>
        <input *ngIf="data['selected_row'].editName" [(ngModel)]="data['selected_row'].name" type="text"
          class="form-control" />
        <!-- <mat-icon class="pull-right text-green" (click)="data['selected_row'].editName = true">edit</mat-icon>
        <mat-icon class="pull-right text-green" (click)="data['selected_row'].editName = false">save</mat-icon> -->
      </div>
    </div>
    <div class="d-flex">
      <h4>{{'app.device-type' | translate}}</h4>
      <h4 class="ml-auto">{{data["selected_row"].type}}</h4>
    </div>
    <div class="d-flex">
      <h4>{{'app.room' | translate}}</h4>
      <h4 class="ml-auto">{{data["selected_row"].room}}</h4>
    </div>
    <div class="d-flex align-items-center" *ngIf="data['selected_row'].name==='DHW'">
      <h4>{{'app.status' | translate}}</h4>
      <div class="ml-auto d-flex align-items-center">
        <span [ngStyle]="{'color': activity === 'ON' ? 'green' : 'lightgrey'}" class="material-icons mr-1">circle</span>
        <mat-slide-toggle [checked]="activity === 'ON'" class="ml-2 align-self-center"
          (change)="onToggleChange($event)"></mat-slide-toggle>
      </div>
    </div>
  </div>

  <div class="border border-grey rounded p-3" *ngIf="data['selected_row'].name!=='DHW'">
    <h3 class="weight-500 pt-2">{{'app.current-status' | translate}}</h3>
    <hr>
    <div class="row">
      <div class="col-xl-2 col-lg-2">
        <p class="text-center">{{'app.status' | translate}}</p>
        <div class="text-center" style="margin-top: 20px;">
          <ng-container *ngIf="activity; else noActivity">
            <span [ngStyle]="{'color': activity === 'ON' ? 'green' : 'lightgrey'}"
              class="material-icons mr-1">circle</span>
            <mat-slide-toggle [checked]="activity === 'ON'" class="ml-2"
              (change)="onToggleChange($event)"></mat-slide-toggle>
          </ng-container>
          <ng-template #noActivity>
            -
          </ng-template>
        </div>
      </div>
      <div class="col-xl-3 col-lg-3">
        <p class="text-center">{{ 'app.operation-mode' | translate }}</p>
        <div class="d-flex justify-content-center" *ngIf="mode; else noMode">
          <img *ngFor="let m of ['COOL', 'HEAT', 'FAN', 'DRYER', 'AUTO']"
            [src]="'./../assets/images/svgs/' + m.toLowerCase() + '-' + (mode === m ? 'active' : 'inactive') + '.svg'"
            width="35" height="40" (click)="changeMode(m)">
        </div>
        <ng-template #noMode>
          -
        </ng-template>
      </div>      
      <div class="col-xl-3 col-lg-3">
        <p class="text-center">{{'app.temperature' | translate}} °C</p>
        <div class="text-center">
          <ng-container *ngIf="temperature; else noTemperature">
            <h2 class="mb-0 d-inline-block">{{temperature}}</h2>
            <img src="./../assets/images/svgs/up.svg" width="35" height="40" (click)="increment()" class="d-inline-block">
            <img src="./../assets/images/svgs/down.svg" width="35" height="40" (click)="decrement()" class="d-inline-block">
          </ng-container>                   
          <ng-template #noTemperature>
            -
          </ng-template>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4">
        <p class="text-center">{{'app.fan-speed' | translate}}</p>
        <div class="text-center">
          <div *ngIf="fanspeed; else nofanSpeed" class="d-flex justify-content-center align-items-center">
            <ng-container *ngFor="let speed of ['1', '2', '3','4', 'AUTO']">
              <img class="mr-1"
                [src]="'./../assets/images/svgs/fan-' + (speed === 'AUTO' ? 'auto' : 'medium') + '-' + (fanspeed === speed ? 'active' : 'inactive') + '.svg'"
                width="35" height="40" [attr.disabled]="speed === 'AUTO' ? true : null"
                (click)="speed !== 'AUTO' ? onFanSpeedClick(speed) : null">
            </ng-container>
          </div>
          <ng-template #nofanSpeed>
            -
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="daily-scheduling border border-grey rounded p-3" *ngIf="data['selected_row'].name==='DHW'">
    <div class="d-flex">
      <img src="./../assets/images/svgs/calendar.svg" height="25" class="mr-2">
      <h4 class="weight-500">{{'app.activate-scheduling' | translate}}</h4>
      <div class="ml-auto activateScheduling">
        <div class="checkbox-switch">
          <input type="checkbox" [checked]="this.activateScheduling" (change)="toggleSlide($event)" value="1"
            name="status" class="input-checkbox" id="toolbar-active">
          <div class="checkbox-animate">
            <span class="checkbox-off">OFF</span>
            <span class="checkbox-on">ON</span>
          </div>
        </div>
      </div>
    </div>
    <div id="timeRangeContainer">
      <h5>{{'app.exclude-devic-from-dr-events' | translate}}</h5>
      <div class="d-flex">
        <div class="cs-form col-5">
          <input type="time" class="form-control" [(ngModel)]="startTime" step="3600"
            [disabled]="!activateScheduling" />
        </div>
        <div class="cs-form col-5">
          <input type="time" class="form-control" [(ngModel)]="endTime" step="3600" [disabled]="!activateScheduling" />
        </div>
        <div class="cs-form col-2 addSchedule">
          <mat-icon class="text-green" (click)="submitTimeRange()">add_circle</mat-icon>
        </div>
      </div>
      <div class="selection-box">
        <div class="no-scheduling-plan" *ngIf="!timeRanges.length">
          {{'app.no-scheduling-plan' | translate}}
        </div>
        <div class="d-inline" *ngFor="let timeRange of timeRanges">
          <span class="chip" [ngStyle]="{'color': activateScheduling ? '' : 'gray'}">
            {{ timeRange.start | slice: 0:5 }} - {{ timeRange.end | slice: 0:5 }}
            <mat-icon (click)="removeTimeRange(timeRange)">close</mat-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-center mt-2">
  <div class="save-button">
    <button class="btn bg-green text-white" (click)="save()">
      <mat-icon class="align-middle">save</mat-icon> {{'app.save-changes' | translate}}
    </button>
  </div>
</mat-dialog-actions>